export function calcTotalSeconds(seconds = 0, minutes = 0, hours = 0) {
  return seconds + minutes * 60 + hours * 3600;
}
